import React from 'react'
import './Comments.css'
import { Row, Col } from 'reactstrap'
import CommentInput from './CommentInput'
import Comment from './Comment'

export default function Comments({ event, ev_comments, setComments }) {
  // ev_comments.sort((a, b) => {
  //   const d_a = new Date(a.event_comment_created_at)
  //   const d_b = new Date(b.event_comment_created_at)
  //   const _return = d_a < d_b ? 1 : d_b < d_a ? -1 : 0
  //   return _return
  // })

  return (
    <>
      <Row>
        <Col>
          <h3>Comments</h3>
        </Col>
      </Row>
      <CommentInput
        event={event}
        rows_size={2}
        ev_comments={ev_comments}
        setComments={setComments}
      />
      {ev_comments.map(ev_comment => {
        return (
          <Comment
            event={event}
            ev_comments={ev_comments}
            ev_comment={ev_comment}
            setComments={setComments}
            key={`event_comment_${ev_comment.event_comment_id}`}
          />
        )
      })}
    </>
  )
}
